// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"cf3bcf1a","435":"9647c0cb","591":"e9d847a3","624":"82b1299c"}[chunkId] + ".chunk.js";
};